import useAuth from "../../hooks/useAuth";
import { useEffect, useState } from "react";
import CategoryDropdownL1 from "../../components/CategoryDropdownL1";
import CategoryDropdownL2 from "../../components/CategoryDropdownL2";
import CategoryDropdownRoles from "./components/CategoryDropdownRoles";
import Button from "../../components/Button";
import ExitButton from "../../components/ExitButton";
import authFetch from "../../api/authFetch";

const Settings = ({successHandler}) => {

    const {auth, setAuth} = useAuth();
    const [editName, setEditName] = useState(false);
    const [newName, setNewName] = useState(auth?.username);
    const [nameError, setNameError] = useState("");
    const [editEmail, setEditEmail] = useState(false);
    const [newEmail, setNewEmail] = useState(auth?.email);
    const [emailError, setEmailError] = useState("");
    const [newRole, setNewRole] = useState(auth?.role);
    const [l1, setL1] = useState("");
    const [l2, setL2] = useState("");
    const [notifs, setNotifs] = useState([]);

    const unauthorize = () => {
        localStorage.removeItem("token");
        setAuth({});
    }

    const updateAuth = async () => {
        const token = localStorage.getItem("token");
        const response = await authFetch(`/users/me`, { method: "GET" });
        if (response.ok) {
            let userData = await response.json();
            userData.token = token;
            setAuth(userData);
        }
    }

    const getNameError = async (name) => {
        if (name === auth?.username) {
            return "This username is identical to the previous.";
        }
        if (name === "") {
            return "Username is required.";
        }
        for (let c of [" ", "/"]) {
            if (name.includes(c)) {
                return `Username cannot include \"${c}\".`;
            }
        }
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/name-exists/${name}`);
        if (response.ok) {
            const json = await response.json();
            if (json.exists) {
                return "This username is taken.";
            }
        }
        return null;
    }

    const changeName = async (name) => {
        setNewName(name);
        setNameError(await getNameError(name));
    }

    const updateName = async () => {
        const err = await getNameError(newName);
        if (err) {
            setNameError(err);
        } else {
            setNameError("");
            const response = await authFetch(`/users/update-username/${newName}`, {
                method: "POST"
            });
            if (response.ok) {
                updateAuth();
                setEditName(false);
            } else {
                switch(response.status) {
                    case 401:
                        unauthorize();
                        break;
                    case 409:
                        setNameError(`Username ${newName} is already taken`);
                        break;
                }
            }
        }
    }

    const getEmailError = async (email) => {
        if (email === auth?.email) {
            return "This email is identical to the previous.";
        }
        if (email === "") {
            return "Email is required.";
        }
        if (!email.includes("@")) {
            return "Email must be in the format of 'email@email.com'.";
        }
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/email-exists/${email}`);
        if (response.ok) {
            const json = await response.json();
            if (json.exists) {
                return "This email is taken.";
            }
        }
        return null;
    }

    const changeEmail = async (email) => {
        setNewEmail(email);
        setEmailError(await getEmailError(email));
    }

    const updateEmail = async (evnt) => {
        const err = await getEmailError(newEmail);
        if (err) {
            setEmailError(err);
        } else {
            setEmailError("");
            const response = await authFetch(`/users/update-email/${newEmail}`, {
                method: "POST"
            });
            if (response.ok) {
                updateAuth();
                setEditEmail(false);
            } else {
                switch(response.status) {
                    case 401:
                        unauthorize();
                        break;
                    case 409:
                        setEmailError(`Email ${newEmail} is already taken`);
                        break;
                }
            }
        }
    }

    const updateL1 = async (newL1) => {
        const response = await authFetch(`/users/update-l1/${newL1}`, {
            method: "POST"
        });
        if (response.status === 401) {
            unauthorize();
        }
    }

    const updateL2 = async (newL2) => {
        const response = await authFetch(`/users/update-l2/${newL2}`, {
            method: "POST"
        });
        if (response.status === 401) {
            unauthorize();
        }
    }

    const requestAccess = async () => {
        const response = await authFetch(`/users/request-access/${newRole}`, {
            method: "POST"
        });
        if (response.status === 409) {
            localStorage.removeItem("token");
            setAuth({});
        }
    } 

    const acceptInvitation = async (tag) => {
        const response = await authFetch(`/users/accept-invitation/${tag}`, {
            method: "POST"
        });
        if (response.ok) {
            getNotifs();
        }
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
    }

    const denyInvitation = async (tag) => {
        const response = await authFetch(`/users/deny-invitation/${tag}`, {
            method: "POST"
        });
        if (response.ok) {
            getNotifs();
        }
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
    }

    const getNotifs = async () => {
        if (auth?.email !== "guest") {
            const response = await authFetch(`/users/notifs`, {
                method: "GET"
            });
            if (response.ok) {
                const json = await response.json();
                setNotifs(json);
                console.log(json);
            }
            if (response.status === 401) {
                localStorage.removeItem("token");
                setAuth({});
            }
        }
    }

    const removeNotif = async (index) => {
        const response = await authFetch(`/users/notif/${index}`, {
            method: "DELETE"
        });
        if (response.ok) {
            getNotifs();
        }
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
    }

    const clearNotifs = async () => {
        const response = await authFetch(`/users/notifs`, {
            method: "DELETE"
        });
        if (response.ok) {
            getNotifs();
        }
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
    }

    const ErrorDiv = ({err}) => {
        if (err) {
            return (
                <div className="text-red-500">
                    {err}
                </div>
            );
        }
    }


    useEffect(() => {
        authFetch(`/users/get-l1`, {
            method: "GET"
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            if (response.status === 401) {
                localStorage.removeItem("token");
                setAuth({});
            }
        }).then(json => {
            if (json) {
                setL1(json.l1);
            }
        });
    }, []);

    useEffect(() => {
        const token = localStorage.getItem("token");
        authFetch(`/users/get-l2`, {
            method: "GET"
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            if (response.status === 401) {
                localStorage.removeItem("token");
                setAuth({});
            }
        }).then(json => {
            if (token) {
                setL2(json.l2);
            }
        });
    }, []);

    useEffect(() => {getNotifs()}, []);

    return <main className="page-shell">
        <div className="page-container max-w-6xl">
        <div className="page-header">
            <ExitButton func={()=> {successHandler(false)}} />
            <div>
                <p className="panel-heading">Account</p>
                <h1 className="page-heading">Settings</h1>
                <p className="page-subtitle">Manage your profile, languages, access, and notifications.</p>
            </div>
        </div>

        <div className="account-grid">
            <section className="panel panel-body">
                <h2 className="panel-heading mb-2">Profile details</h2>
                <div>
                    <div className="account-row">
                    <div className="account-label">Username</div>
                    {editName ? <div className="flex flex-col">
                        <input
                            className="form-field"
                            type="text"
                            defaultValue={auth?.username}
                            onChange={e => changeName(e.target.value)}
                        />
                        <ErrorDiv err={nameError} />
                    </div> : <div className="account-value">{auth?.username}</div>}
                    {editName ? <Button
                        text="Update"
                        func={updateName}
                    /> : <Button
                        text="Edit"
                        func={() => setEditName(true)}
                    />}
                        
                    </div>
                    <div className="account-row">
                    <div className="account-label">Email address</div>
                    {editEmail ? <div className="flex flex-col">
                        <input
                            className="form-field"
                            type="text"
                            defaultValue={auth?.email}
                            onChange={e => changeEmail(e.target.value)}
                        />
                        <ErrorDiv err={emailError} />
                    </div> : <div className="account-value">{auth?.email}</div>}
                    {editEmail ? <Button
                        text="Update"
                        func={updateEmail}
                    /> : <Button
                        text="Edit"
                        func={() => setEditEmail(true)}
                    />}
                    
                    </div>
                    <div className="account-row">
                    <div className="account-label">Role</div>
                    <CategoryDropdownRoles selectHandler={e => setNewRole(e.target.value)} elValue={newRole} />                        
                    {newRole !== auth?.role ? <Button
                        text="Request"
                        func={requestAccess}
                    /> : <div />}

                    </div>
                    <div className="account-row">
                    <div className="account-label">Native language</div>
                    <CategoryDropdownL1 selectHandler={e => updateL1(e.target.value)} elValue={l1} />
                    <div />
                    
                    </div>
                    <div className="account-row">
                    <div className="account-label">Language course</div>
                    <CategoryDropdownL2 selectHandler={e => updateL2(e.target.value)} elValue={l2} />
                    <div />
                    </div>
                </div>
            </section>
            <aside className="panel panel-body">
                <div className="mb-4 flex items-center justify-between gap-3">
                    <h2 className="panel-heading">Notifications</h2>
                    {notifs.length !== 0 && <Button text="Clear all" func={clearNotifs} variant="ghost"/>}
                </div>
                <div className="panel-stack">
                {notifs.map((notif, i) => {
                    return (
                    <div className="notification-row" key={`${notif.course}-${i}`}>
                        <div className="font-bold text-cyan-900">{notif.course}</div>
                        <div className="my-2 text-sm text-slate-600">{notif.detail}</div>
                        <div className="flex flex-wrap gap-2">
                        {notif.type === "INVITATION" &&
                            <>
                                <Button text="Accept" func={() => acceptInvitation(notif.course)} />
                                <Button text="Decline" func={() => denyInvitation(notif.course)} variant="secondary" />
                            </>
                        }
                        <Button text="Dismiss" func={() => removeNotif(i)} variant="ghost"/>
                        </div>
                    </div>
                    )
                })}
                {notifs.length === 0 && <div className="empty-state">You are all caught up.</div>}
                </div>
            </aside>
        </div>
        </div>
    </main>
}

export default Settings;
